export const FIELDS = {
  DATA: 'data',
  PAGES: 'pages',
  STAGES: 'stages',
};

export const ERROR_TYPES = {
  BACKEND: 'backend',
  FRONTEND: 'frontend',
};

export const ABSTRACT_WATCHER_ACTION_SYMBOL = Symbol('action');
export const ABSTRACT_WATCHER_NAME_SYMBOL = Symbol('name');

export * from './actions';
export * from './data';
export * from './pages';
export * from './shared';
export * from './stages';
